import { render, staticRenderFns } from "./EMelderComponentMeldenBs5EingabeDatum.vue?vue&type=template&id=05617165"
import script from "./EMelderComponentMeldenBs5EingabeDatum.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs5EingabeDatum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports